import React, { useState } from "react";
import { DialogOverlay, DialogContent } from "@reach/dialog";
import "@reach/dialog/styles.css";
import { createGlobalStyle } from "styled-components";

import { Box } from "../globals";
import Text from "../text";

const GlobalStyles = createGlobalStyle`
  .covid19[data-reach-dialog-overlay] {
    z-index: 9999 !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
  .covid19 [data-reach-dialog-content] {
    width: 90% !important;
    max-width: 640px !important;
    margin: 20vh auto !important;
    padding: 0 !important;
    font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #fff;
    background-color: #000;
  }
  @media (max-width: 600px) {
    .covid19 [data-reach-dialog-content] {
      margin: 10vh auto !important;
    }
  }
`;

function Covid19() {
  const [showDialog, setShowDialog] = useState(true);
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);

  return (
    <>
      <GlobalStyles />

      <DialogOverlay className="covid19" isOpen={showDialog} onClick={close}>
        <DialogContent>
          <Box p={[32, 48]} onClick={close}>
            <Box position="relative">
              <button
                css={`
                  position: absolute;
                  top: 0;
                  right: 0;
                  margin: 0;
                  padding: 0;
                  border: 0;
                  background: 0;
                  appearance: none;
                  cursor: pointer;
                `}
                onClick={close}
              >
                <svg width="24" height="24" viewBox="0 0 94 94" fill="none">
                  <path
                    d="M47 49.6569L90.6812 93.3381L93.5097 90.5097L49.8284 46.8284L93.3381 3.31876L90.5097 0.490334L47 44L3 0L0.171573 2.82843L44.1716 46.8284L0 91L2.82843 93.8284L47 49.6569Z"
                    fill="white"
                  />
                </svg>
              </button>
              <svg
                width={(2000 / 787.75) * 56}
                height={56}
                viewBox="0 0 2000 787.75"
                css={`
                  vertical-align: top;
                `}
              >
                <title>Anthem United</title>
                <path
                  d="M92.36 144.47L0 433h77.07l15.29-53.71H188L203.38 433h87.52l-91.58-288.53zm16.13 177.91l31.89-111 31.51 111zM445.65 216.28c-35 0-58 17.74-69.35 39.58v-33.92h-72.24V433h72.24V314.72c0-27 14.53-39.9 35.86-39.9 21.1 0 30.32 11.67 30.32 35.49V433h72.27V295.72c0-54.01-28.33-79.44-69.1-79.44zM666.21 376.87a55.05 55.05 0 0 1-20.54 3.65c-13.75 0-21.35-6.88-21.35-22.16v-87.15h41.55v-49.27h-41.55v-44H552v44h-25.37v49.27H552v94c0 49.56 26.69 72.63 74.24 72.63 17 0 30.75-3.66 40-6zM824.32 310.32V433h72.25V295.74c0-54-28.23-79.46-69-79.46-35.09 0-58.13 17.76-69.43 39.58V129.14H686V433h72.1V314.71c0-27 14.53-39.87 36-39.87 20.96 0 30.22 11.64 30.22 35.48zM1027.54 437.83c63.72 0 100.44-27.05 107-74.64h-67.74c-2.94 14.07-13 25-36.81 25-25.83 0-42-16.2-43.94-44h148.46v-19c0-75.85-49.67-108.9-107.33-108.9-63.78 0-114.27 42.77-114.27 110.52v3.26c0 69.06 48.45 107.76 114.63 107.76zm-.36-173.91c23.37 0 35.83 14.08 37.1 39.54h-77.43c3.56-25.46 18.49-39.54 40.33-39.54zM1417.55 216.28c-26.56 0-51.66 10.47-69.7 35.09-10.19-22.92-29.52-35.09-57.35-35.09-32.69 0-54.87 17.74-66.21 37.92v-32.26h-72.17V433h72.17V310.64c0-22.94 12.9-35.42 32.31-35.42 16.54 0 27.06 10.45 27.06 31.82V433H1355V310.64c0-22.94 13-35.42 32.38-35.42 16.54 0 27 10.45 27 31.82V433h72.17V295c.01-52.9-29-78.72-69-78.72zM191.66 662.56c0 42.6-10.83 61-44.64 61-34.72 0-44.68-19.6-44.68-59.84V497.79H20.58v169.49c0 79.78 45.87 120.45 126.44 120.45 78.61 0 127.23-38.69 127.23-121.63V497.79h-82.59zM445.62 568.78c-34.78 0-57.5 17.52-68.63 39.12v-33.54h-71.42V783H377V666.09c0-26.72 14.34-39.48 35.5-39.48 20.71 0 29.88 11.55 29.88 35.06V783h71.36V647.34c-.01-53.43-27.93-78.56-68.12-78.56zM577.29 480.71c-22.34 0-39 15.85-39 37.05s16.65 36.65 39 36.65 39.48-15.52 39.48-36.65-17.1-37.05-39.48-37.05zM541.79 574.36h71.41v208.61h-71.41zM725.19 709.15v-86.09h41.08v-48.7h-41.08v-43.47H653.8v43.47h-25v48.7h25v92.88c0 49.1 26.34 71.81 73.35 71.81 16.85 0 30.35-3.61 39.5-5.94V727.5a52.73 52.73 0 0 1-20.31 3.56c-13.61 0-21.15-6.72-21.15-21.91zM887.89 568.78C824.91 568.78 775 611 775 678.06v3.22c0 68.17 47.85 106.45 113.25 106.45 63 0 99.3-26.7 105.72-73.81H927c-2.82 14-12.8 24.73-36.31 24.73-25.52 0-41.52-15.92-43.49-43.45H994v-18.78c0-74.9-49.11-107.64-106.11-107.64zM848 655c3.61-25.22 18.33-39.13 39.91-39.13 23.15 0 35.47 13.91 36.74 39.13zM1153.82 603.88c-12-21.12-31.61-35.11-64.22-35.11-49.46 0-88.54 37.85-88.54 108.91v3.16c0 72.18 39.43 106.91 87.69 106.91 31.53 0 54.71-17.12 65.07-38.72V783h71.35V482.63h-71.35zm2 75.85c0 35.43-16 53.38-41.89 53.38-24.73 0-40.28-18-40.28-53.05v-3.22c0-36.23 14.41-54.18 41.06-54.18 26.33 0 41.11 18.7 41.11 53.77zM2000 288.55L1855.8 144.3h-144.3L1855.8 0h-144.31l-144.28 144.31h144.28l.01-.01 144.29 144.24h-144.3L1567.2 432.82h144.29l144.31-144.27H2000z"
                  fill="#fff"
                />
              </svg>
              <Text
                mt="0.75em"
                fontWeight={700}
                color="inherit"
                style={{ fontSize: 32, lineHeight: 1 }}
              >
                Showhome Hours May Vary
              </Text>
              <Text
                mt="1em"
                fontWeight={600}
                color="inherit"
                style={{ fontSize: 16 }}
              >
                Your health, safety and comfort are our top priority.
              </Text>
              <Text
                mt="1em"
                fontWeight={600}
                color="inherit"
                style={{ fontSize: 16 }}
              >
                As we continue to closely monitor the evolving COVID-19
                situation, we encourage those planning an in-person visit to
                connect directly with our Presentation Centers for up-to-date
                hours and alternative ways to connect.
              </Text>
              <Text
                mt="1em"
                fontWeight={600}
                color="inherit"
                style={{ fontSize: 16 }}
              >
                Thank you for your support and understanding.
              </Text>
            </Box>
          </Box>
        </DialogContent>
      </DialogOverlay>
    </>
  );
}

export default Covid19;
